export const RELEASE_NOTES_MODAL_TYPES = {
	DELETE_RELEASE_NOTE_MODAL: 'deleteReleaseNoteModal',
}
